import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Dropdown, Badge } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import AddArea from './../../../modal/Branch_Management/Manage_Branch/AddArea';
import AddDelivery from './../../../modal/Branch_Management/Manage_Branch/AddDeliveryPoint';
import AssignCenterHead from './../../../modal/Branch_Management/Manage_Branch/AssignCenterHead';
import ViewBranch from './../../../modal/Branch_Management/Manage_Branch/ViewBranch';
import axios from 'axios';
import AssignCUG from './../../../modal/Branch_Management/Manage_Branch/AsignCUG';
import EditArea from '../../../modal/Branch_Management/Manage_Branch/EditArea';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingComponent from '../../../layouts/nav/loading';

const Branch = () => {

    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,

        // ----------------------- branch --------------------
        man_branch: 0,
        branch_list: 0,
        branch_add: 0,
        branch_edit: 0,
        branch_view: 0,
        branch_delete: 0,
        branch_add_staff: 0,
        branch_add_area: 0,
        branch_add_dpoint: 0,
        branch_asign_manager: 0,
        branch_asign_cug: 0,
        
        man_dpoint: 0,
        dpoint_list: 0,
        dpoint_edit: 0,
        dpoint_delete: 0,
        dpoint_assign_vehicle: 0,

        // --------------------------- pack -------------------
        pack_man: 0,
        man_product: 0,
        prod_catego: 0,
        product_category_list: 0,
        product_category_add: 0,
        product_category_edit: 0,
        product_category_delete: 0,

        product: 0,
        products_list: 0,
        products_add: 0,
        products_edit: 0,
        products_view: 0,
        products_delete: 0,
        products_item_quantity: 0,

        item_quans: 0,
        item_quantity_list: 0,
        item_quantity_edit: 0,
        item_quantity_view: 0,

        man_pack: 0,
        package_list: 0,
        package_edit: 0,
        package_delete: 0,

        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list : 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,

        // ------------------------------- subscription ------------------
        subs_man: 0,
        man_subs: 0,
        subscription_list: 0,
        subscription_view: 0,
        subscription_edit: 0,
        subscription_export: 0,
        subscription_hold: 0,
        subscription_complaints: 0,
        subscription_renewal: 0,
        subscription_payment: 0,
        subscription_drop: 0,
        subscription_special_case: 0,

        man_order: 0,
        order_list: 0,
        order_edit: 0,
        order_view: 0,
        order_new_subs: 0,
        order_drop_subs: 0,
        order_convert_subscriber: 0,

        man_drop: 0,
        drop_list: 0,
        drop_export: 0,

        // ----------------------------------- payment ------------------------
        pay_man: 0,
        man_payment: 0,
        payment_export: 0,
        payment_list: 0,
        
        man_refund: 0,
        refund_list: 0,
        refund_export: 0,
        refund_update: 0,

        // -------------------------- production ----------------------
        prod_man: 0,
        man_items: 0,
        item_catego: 0,
        item_category_list: 0,
        item_category_add: 0,
        item_category_edit: 0,
        item_category_delete: 0,

        item_sub_catego: 0,
        item_sub_category_list: 0,
        item_sub_category_add: 0,
        item_sub_category_edit: 0,
        item_sub_category_delete: 0,

        items: 0,
        items_list: 0,
        items_add: 0,
        items_edit: 0,
        items_view: 0,
        items_delete: 0,
        item_needed_material: 0,
        item_receipe_notes: 0,

        comp_man: 0,
        complaint_list: 0,
        complaint_add: 0,
        complaint_status: 0,
        complaint_view: 0,

        maintenance_man: 0,
        man_vehi: 0,
        vehicle_list: 0,
        vehicle_add: 0,
        vehicle_edit: 0,
        vehicle_view: 0,
        vehicle_delete: 0,
        vehicle_maintannce: 0,
        vehicle_export: 0,

        man_mainten: 0,
        maintenance_list: 0,
        maintenance_edit: 0,
        maintenance_status: 0
    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);

    const [branch, setbranch] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [hasFetched, setHasFetched] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [TotalCount, setTotalCount] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchBranches = (filter = {}) => {
        setLoading(true);
        const params = {
            ...filter,
            page,
            per_page: perPage,
            search: searchTerm
        };

        axios.get(`${baseURL}/managebranch`, { params })
            .then(response => {
                const branches = response.data.data?.data || [];
                const total = response.data.data?.total || 0;
                const lastPage = response.data.data?.last_page || 1;

                setbranch(branches);
                setTotalCount(total);
                setTotalPages(lastPage);
                setHasFetched(true);
                setLoading(false);
                
            })
            .catch(error => {
                console.error('Error fetching branches!', error);
                setHasFetched(true);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchBranches();
    }, [page, perPage, searchTerm]);

    const tableRef = useRef(null);
    
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    // cug
    const [selbranchdata, setselbranchdata] = useState({});
    const handleModalToggleCUG = (id, data) => {
        setSelectedBranch(id);
        setselbranchdata(data);
        setModalType("CUG");
        setOpen(true);
    };

    const [selbranchname, setselbranchname] = useState('');
    const handleModalToggleArea = (branchItem, name) => {
        // console.log("Selected Branch:", branchItem);
        setSelectedBranch(branchItem);
        setselbranchname(name);
        setModalType("AddArea");
        setOpen(true);
    };
    const handleModalToggleDelivery = (branchItem) => {
        setSelectedBranch(branchItem);
        setModalType("AddDelivery");
        setOpen(true);
    };
    const handleModalToggleCenHead = (branchItem) => {
        setSelectedBranch(branchItem);
        setModalType("AddCenterHead");
        setOpen(true);
    };
    const handleModalToggleViewBranch = (branchItem) => {
        setSelectedBranch(branchItem);
        setModalType("ViewBranch");
        setOpen(true);
    };
    const DeleteModal = (branchItem) => {
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose One ${branchItem.manage_branch_type === 1 ? 'Franchise' : 'Branch'}
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>${branchItem.branch_name}</b></p>
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <defs>
                            <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#5987dd"/>
                                <stop offset=".118" stop-color="#638bd6"/>
                                <stop offset=".316" stop-color="#7d98c3"/>
                                <stop offset=".572" stop-color="#a8aba3"/>
                                <stop offset=".871" stop-color="#e3c678"/>
                                <stop offset="1" stop-color="#ffd364"/>
                            </radialGradient>
                            <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                        </defs>
                        <g id="_27-feel_bad" data-name="27-feel bad">
                            <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                            <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                            <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="34" cy="22" r="1"/>
                            <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="16" cy="22" r="1"/>
                            <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                            <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                            <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                            <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                            <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                            <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                            <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                            <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                            <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                            <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                            <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                        </g>
                    </svg>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${baseURL}/managebranch/${branchItem.sno}`)
                    .then(response => {
                        // Remove the deleted item from state
                        setbranch(prev => prev.filter(b => b.sno !== branchItem.sno));
                        // swal.fire('Deleted!', 'Branch has been deleted.', 'success');
                        // window.location.reload();
                        toast.success("Branch Deleted Successfully!");
                    })
                    .catch(error => {
                        console.error("Error deleting branch:", error);
                        // swal.fire('Error', 'Something went wrong while deleting.', 'error');
                        toast.error("Branch Deletion Failed");
                    });
            }
        });
    };

    const handleStatusToggle = async (sno, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;
        axios.put(`${baseURL}/managebranch/status/${sno}`, {status: newStatus})
            .then(response => {
                // window.location.reload();
                fetchBranches();
                toast.success("Status Updated Successfully!");
            })
            .catch(error => {
                console.log(error);
                toast.error("Status Updation Failed");
            });
    };

    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "destroy": true,
                        "paging": false,
                        "searching": false,
                        "info": false,
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched, branch]);
// 29-10-2025
    
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10) || 1;

    const [isMaintenance, setIsMaintenance] = useState(false);
    // const [loading, setLoading] = useState(true);

useEffect(() => {
    let isMounted = true;

    const checkMaintenanceStatus = async () => {
        try {
            const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
            const data = response.data.data || [];
            const branchStatus = data.find((item) => item.slug === "managebranch"); // use managebranch slug

            if (isMounted) {
                setIsMaintenance(branchStatus?.maintenancemode_status === 1);
            }
        } catch (error) {
            console.error("Error checking maintenance mode:", error);
            if (isMounted) setIsMaintenance(false);
        } finally {
            if (isMounted) setLoading(false);
        }
    };

    checkMaintenanceStatus();

    return () => {
        isMounted = false;
    };
}, [baseURL, branch_id]);

if (loading) {
    return <div>Loading...</div>; // optional loading state
}

if (isMaintenance) {
    return (
        <div
            className="d-flex flex-column align-items-center justify-content-center text-center"
            style={{ height: "100vh", width: "100vw" }}
        >
            <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
            <p className="text-muted fs-5">
                The <strong>Manage Branch</strong> module is currently under maintenance. <br />
                Please check back later.
            </p>
        </div>
    );
}

// 29-10-2025

    return (
        <>
            <LoadingComponent loading={loading} />

            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Branch</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Branch Management</li>
                    </ol>
                </div>

                {permissions.branch_add === 1 && (
                    <Link to={"/add-branch"} className="btn btn-primary float-end btn-sm">
                        <span className='me-2'><i className="fa-solid fa-plus fs-8"></i></span>
                        <span className=''>Add Branch</span>
                    </Link>
                )}

                {open && modalType === "AddDelivery" && (
                    <AddDelivery show={open} onClose={() => setOpen(false)} selectedBranch={selectedBranch} onSuccess={(newDeliveryPoint) => {
                    // Here, you can update the branch state or refetch counts
                    // For example, just refetch branches (simpler):
                    fetchBranches();
                    setOpen(false);
                    }} />
                )}
                {open && modalType === "AddCenterHead" && (
                    <AssignCenterHead show={open} onClose={() => setOpen(false)} selectedBranch={selectedBranch}  refresh={fetchBranches} />
                )}
                {open && modalType === "ViewBranch" && (
                    <ViewBranch show={open} onClose={() => setOpen(false)} branchData={selectedBranch} />
                )}

                {open && modalType === "CUG" && (
                    <AssignCUG show={open} onClose={() => setOpen(false)} selectedid={selectedBranch} data={selbranchdata} />
                )}
                {open && modalType === "AddArea" && (
                    <EditArea show={open} onClose={() => setOpen(false)} branch={selectedBranch} name={selbranchname} onSuccess={fetchBranches}/>
                )}
            </div>

            {permissions.branch_list === 1 && (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{  fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1); // Reset to first page
                                }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <input
                                type="text"
                                style={{  fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1); // Reset page on new search
                                }}
                            />
                        </div>
                    </div>
                    <table ref={tableRef} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='min-w-50px text-start'>Branch / Franchise</th>
                                <th className='min-w-100px'>Email / Mobile No</th>
                                <th className='min-w-100px'>Manager</th>
                                <th className='min-w-100px text-center'><OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    placement="bottom"
                                    overlay={
                                        <Tooltip className="toltip-popover">
                                            <span className="fs-8 text-white fw-semibold">Area / Delivery Point</span>
                                        </Tooltip>
                                    }
                                >
                                    <label className="">Area / DP Count</label>
                                </OverlayTrigger></th>
                                <th className='min-w-50px'>Status</th>
                                <th className='min-w-100px'>Action</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {branch.map((type, index) => (
                                <tr key={type.sno}>
                                    <td>
                                        <label className='text-black font-w400 fs-7'>{type.branch_name}</label>
                                        <div className="d-block">
                                            <label className="fs-8 text-dark">{type.manage_branch_type === 0 ? "Branch" : "Franchise"}</label>
                                        </div>
                                    </td>
                                    <td>
                                        <label className='text-black font-w400 fs-7'>{type.business_email_id}</label>
                                        <div className="d-block">
                                            <label className="fs-8 text-dark">{type.business_mobile_no}</label>
                                        </div>
                                    </td>
                                    <td>
                                        {type.assign_manager && type.assign_manager.length > 0 ? (
                                        <>
                                        <label className='text-black font-w400 fs-7'>{type.assign_manager[0].employee_name}</label>
                                        <div className="d-block">
                                            <label className="fs-8 text-dark me-2">{type.assign_manager[0].phone_no}</label>
                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{type.assign_manager[0].mail_id}</span></Tooltip>} >
                                                <label>
                                                    <span><i className="fa-solid fa-envelope fs-5 mt-1"></i></span>
                                                </label>
                                            </OverlayTrigger>
                                        </div>
                                        </>
                                        ) : (
                                            <span className="fs-7 text-muted">-</span>
                                        )}
                                    </td>
                                    <td>
                                        <div className='d-flex align-items-center gap-2 flex-wrap justify-content-center'>
                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Area Count</span></Tooltip>} >
                                                <Badge bg="warning" className='text-white fs-7 py-0 px-1'>{type.area_count}</Badge>
                                            </OverlayTrigger>
                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delivery Point Count</span></Tooltip>} >
                                                <Badge bg="info" className='text-white fs-7 py-0 px-1'>{type.delivery_point_count}</Badge>
                                            </OverlayTrigger>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="form-check form-switch d-flex align-items-center mb-3">
                                            <input className="form-check-input me-2" type="checkbox" role="switch" checked={type.status === 0} onChange={() => handleStatusToggle(type.sno, type.status)} disabled={permissions.branch_edit !== 1} />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex">

                                            {permissions.branch_add_staff === 1 && (
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Add Staff</span></Tooltip>} >
                                                    <Link to={`/manage-add-staff?data=${type.sno}`}>
                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1 mt-1">
                                                            <svg fill="#025d3a" height="24px" width="24px" version="1.1" viewBox="0 0 328 328">
                                                                <g strokeWidth="0"></g>
                                                                <g strokeLinecap="round" strokeLinejoin="round"></g>
                                                                <g>
                                                                    <path d="M223,116.75c-34.488,0-65.145,16.716-84.298,42.47c-7.762-1.628-15.694-2.47-23.702-2.47c-63.411,0-115,51.589-115,115c0,8.284,6.716,15,15,15h125.596c19.246,24.348,49.031,40,82.404,40c57.897,0,105-47.103,105-105S280.897,116.75,223,116.75z M31.325,256.75c7.106-39.739,41.923-70,83.675-70c2.966,0,5.914,0.165,8.841,0.467c-3.779,10.82-5.841,22.44-5.841,34.533c0,12.268,2.122,24.047,6.006,35H31.325z M223,296.75c-41.355,0-75-33.645-75-75s33.645-75,75-75s75,33.645,75,75S264.355,296.75,223,296.75z"></path>
                                                                    <path d="M115,126.75c34.601,0,62.75-28.149,62.75-62.749C177.75,29.4,149.601,1.25,115,1.25c-34.601,0-62.751,28.15-62.751,62.751C52.249,98.601,80.399,126.75,115,126.75z M115,31.25c18.059,0,32.75,14.692,32.75,32.751c0,18.058-14.691,32.749-32.75,32.749c-18.059,0-32.751-14.691-32.751-32.749C82.249,45.942,96.941,31.25,115,31.25z"></path>
                                                                    <path d="M253,206.75h-15v-15c0-8.284-6.716-15-15-15s-15,6.716-15,15v15h-15c-8.284,0-15,6.716-15,15s6.716,15,15,15h15v15c0,8.284,6.716,15,15,15s15-6.716,15-15v-15h15c8.284,0,15-6.716,15-15S261.284,206.75,253,206.75z"></path>
                                                                </g>
                                                            </svg>
                                                        </Button>
                                                    </Link>
                                                </OverlayTrigger>
                                            )}

                                            {permissions.branch_add_area === 1 && (
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Add Area</span></Tooltip>} >
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggleArea(type.sno, type.branch_name)}>
                                                        <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 13V7M15 10.0008L9 10M19 10.2C19 14.1764 15.5 17.4 12 21C8.5 17.4 5 14.1764 5 10.2C5 6.22355 8.13401 3 12 3C15.866 3 19 6.22355 19 10.2Z" stroke="#025d3a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>

                                                    </Button>
                                                </OverlayTrigger>
                                            )}

                                            {permissions.branch_add_dpoint === 1 && (
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Add Delivery Point</span></Tooltip>} >
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggleDelivery(type)}>
                                                        <svg fill="#025d3a" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M6,6H4A1,1,0,0,1,4,4H6V2A1,1,0,0,1,8,2V4h2a1,1,0,0,1,0,2H8V8A1,1,0,0,1,6,8Zm15,4v4a1,1,0,0,1-1,1H16a1,1,0,0,1-1-1V13H8v6h7V18a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v4a1,1,0,0,1-1,1H16a1,1,0,0,1-1-1V21H7a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h8V10a1,1,0,0,1,1-1h4A1,1,0,0,1,21,10ZM17,21h2V19H17Zm2-10H17v2h2Z"></path></g></svg>
                                                    </Button>
                                                </OverlayTrigger>
                                            )}

                                            {permissions.branch_asign_manager === 1 && (
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Assign Manager</span></Tooltip>} >

                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggleCenHead(type)}>
                                                        <svg fill="#025d3a" height="22px" width="22px" version="1.1" id="Layer_1" viewBox="0 0 492.31 492.31" stroke="#025d3a" strokeWidth="13.784624000000003">
                                                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                                            <g id="SVGRepo_iconCarrier">
                                                                <g>
                                                                    <g>
                                                                        <polygon points="401.817,367.952 401.817,322.308 382.125,322.308 382.125,367.952 336.481,367.952 336.481,387.644 382.125,387.644 382.125,433.279 401.817,433.279 401.817,387.644 447.462,387.644 447.462,367.952"></polygon>
                                                                    </g>
                                                                </g>
                                                                <g>
                                                                    <g>
                                                                        <path d="M392.15,277.471c-14.551-19.507-31.998-36.447-52.15-50.144c-1.615-1.106-4.875-3.221-4.875-3.221L327.26,219l-5.481,7.615c-24.096,33.452-63.01,53.433-104.077,53.433c-41.077,0-79.981-19.981-104.077-53.442l-5.5-7.644l-11.904,7.817C35.971,267.356,0,334.904,0,407.462v31.644h312.725c18.37,23.685,47.018,39.019,79.246,39.019c55.327,0,100.337-45.01,100.337-100.327C492.308,322.531,447.394,277.569,392.15,277.471z M19.692,419.414v-11.952c0-64.481,31.231-124.615,83.788-161.769c28,34.01,70.019,54.048,114.221,54.048c44.202,0,86.221-20.038,114.221-54.048c13.962,9.87,26.487,21.413,37.421,34.438c-44.448,10.3-77.709,50.132-77.709,97.668c0,14.855,3.332,28.919,9.153,41.615H19.692z M391.971,458.433c-44.471,0-80.644-36.173-80.644-80.635c0-44.471,36.173-80.644,80.644-80.644s80.644,36.173,80.644,80.644C472.615,422.26,436.442,458.433,391.971,458.433z"></path>
                                                                    </g>
                                                                </g>
                                                                <g>
                                                                    <g>
                                                                        <path d="M217.702,14.183c-59.529,0-107.952,48.433-107.952,107.962c0,59.529,48.423,107.952,107.952,107.952c59.529,0,107.962-48.423,107.962-107.952C325.663,62.615,277.231,14.183,217.702,14.183z M217.702,210.404c-48.663,0-88.26-39.596-88.26-88.26c0-48.673,39.596-88.269,88.26-88.269c48.673,0,88.269,39.596,88.269,88.269C305.971,170.808,266.375,210.404,217.702,210.404z"></path>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </svg>


                                                    </Button>
                                            
                                                </OverlayTrigger>
                                            )}

                                            {permissions.branch_asign_cug === 1 && (
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Assign CUG</span></Tooltip>} >
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggleCUG(type.sno, type)} >
                                                    <i className="fa-solid fa-tty fs-4"></i>
                                                    </Button>
                                                </OverlayTrigger>
                                            )}

                                            {(permissions.branch_view === 1 || permissions.branch_edit === 1 || permissions.branch_delete === 1) && (
                                                <Dropdown drop=''>
                                                    <Dropdown.Toggle
                                                        as="a"
                                                        className="i-false cursor-pointer"
                                                    >
                                                        <Button variant="primary tp-btn-light px-3 py-2">
                                                            <span><i className="fa-solid fa-ellipsis-vertical fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {permissions.branch_view === 1 && (
                                                            <Dropdown.Item href={'#'} className='px-2 py-1' onClick={() => handleModalToggleViewBranch(type)}>
                                                                <div className='d-flex align-items-center'>
                                                                    <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                        <span><i className="fa-solid fa-eye fs-5 text-danger"></i></span>
                                                                    </div>
                                                                    <div className="ms-1 fs-7">View</div>
                                                                </div>
                                                            </Dropdown.Item>
                                                        )}

                                                        {permissions.branch_edit === 1 && (
                                                            <Dropdown.Item as={Link} to="/edit-branch" state={{ branchIdToEdit: type.sno }} className="px-2 py-1">
                                                                <div className='d-flex align-items-center'>
                                                                    <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                        <span><i className="fa-solid fa-pen-to-square fs-5 text-danger"></i></span>
                                                                    </div>
                                                                    <div className="ms-2 fs-7">Edit</div>
                                                                </div>
                                                            </Dropdown.Item>
                                                        )}

                                                        {permissions.branch_delete === 1 && (
                                                            <Dropdown.Item href={"#"} className='px-2 py-1' onClick={() => DeleteModal(type)}>
                                                                <div className='d-flex align-items-center'>
                                                                    <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                        <span><i className="fa-solid fa-trash-can fs-5 text-danger"></i></span>
                                                                    </div>
                                                                    <div className="ms-2 fs-7">Delete</div>
                                                                </div>
                                                            </Dropdown.Item>
                                                        )}

                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            )}

                                            {permissions.branch_add_staff != 1 && permissions.branch_add_area != 1 && permissions.branch_add_dpoint != 1 && permissions.branch_asign_manager != 1  && permissions.branch_asign_cug != 1  && permissions.branch_view != 1  && permissions.branch_delete != 1  && permissions.branch_edit != 1  && (
                                                <div className="text-center">
                                                    No Actions
                                                </div>
                                            )}

                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            {branch.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + branch.length} of {TotalCount} entries
                                </span>
                            ):(
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                </li>
                                {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                </li>
                                ))}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>

                    </div>
                </div>
            )}

            {permissions.branch_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}

        </>
    )


}
export default Branch;